angular.module('rjmNg.directives').directive "applyRestrictionSet", [
  () ->
    restrict: "E"
    templateUrl: "directive.applyRestrictionSet.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      metric: "="
      metricIsValid: "="
      updateReport: "="
      updateMetricValidity: "="
      popover: '='
    controller: [
      "restrictionSetService"
      "utils"
      (
        restrictionSetService
        utils
      ) ->
        view = @

        view.initEditingFilters = () ->
          view.editingFilters = utils.copy(view.metric.filters)
          view.metric.filtersChanged = false
          view.filtersAreValid = true

        view.apply = () ->
          view.metric.filters = utils.copy(view.editingFilters)
          view.metric.filtersChanged = false

          view.updateMetricValidity()

          if view.updateReport?
            view.updateReport()

          view.popover.hide()

        view.cancel = () ->
          view.popover.hide()

        view.checkIfFiltersChanged = () ->
          view.metric.filtersChanged = not restrictionSetService.restrictionSetsAreEqual(view.metric.filters, view.editingFilters)

        view.cleanUp = () ->
          view.metric.filtersChanged = false
          return

        view.$onInit = () ->
          view.initEditingFilters()

        view
    ]
    link: (scope, element, attr, view) ->
      scope.$watch "view.editingFilters", view.checkIfFiltersChanged, true

      scope.$on('$destroy', view.cleanUp)

      scope.$watch('view.popover.visible', (visible, old) ->
        if visible is false
          view.initEditingFilters()
      )
]